// Pinned projects are stored per-user so a fresh login never inherits the
// previous user's sidebar state, even if logout was skipped.
const STORAGE_PREFIX = 'pinnedProjects:';
const LEGACY_LIST_KEY = 'pinnedProjects';
const LEGACY_SINGLE_KEY = 'activeProject';
export const ACTIVE_PROJECT_EVENT = 'activeProjectChanged';

const dispatchChange = () => {
    try {
        window.dispatchEvent(new Event(ACTIVE_PROJECT_EVENT));
    } catch (_) {
        /* ignore */
    }
};

const keyFor = (userId) => (userId ? `${STORAGE_PREFIX}${userId}` : null);

const readForUser = (userId) => {
    const key = keyFor(userId);
    if (!key) return [];
    try {
        const raw = window.localStorage.getItem(key);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) return parsed.filter((p) => p && p.id);
        }
    } catch (_) {
        /* ignore */
    }
    return [];
};

const writeForUser = (userId, arr) => {
    const key = keyFor(userId);
    if (!key) return;
    try {
        window.localStorage.setItem(key, JSON.stringify(arr));
    } catch (_) {
        /* ignore */
    }
    dispatchChange();
};

export const getPinnedProjects = (userId) => readForUser(userId);

export const pinProject = (userId, project) => {
    if (!userId || !project?.id) return;
    const list = readForUser(userId);
    const idx = list.findIndex((p) => String(p.id) === String(project.id));
    if (idx >= 0) {
        if (list[idx].name !== (project.name || 'Project')) {
            list[idx] = { id: project.id, name: project.name || 'Project' };
            writeForUser(userId, list);
        }
        return;
    }
    list.push({ id: project.id, name: project.name || 'Project' });
    writeForUser(userId, list);
};

export const unpinProject = (userId, id) => {
    if (!userId) return;
    writeForUser(userId, readForUser(userId).filter((p) => String(p.id) !== String(id)));
};

export const clearPinnedProjects = (userId) => {
    if (!userId) {
        // Wipe every per-user bucket and the legacy keys.
        try {
            const keys = [];
            for (let i = 0; i < window.localStorage.length; i += 1) {
                const k = window.localStorage.key(i);
                if (k && k.indexOf(STORAGE_PREFIX) === 0) keys.push(k);
            }
            keys.forEach((k) => window.localStorage.removeItem(k));
            window.localStorage.removeItem(LEGACY_LIST_KEY);
            window.localStorage.removeItem(LEGACY_SINGLE_KEY);
        } catch (_) {
            /* ignore */
        }
        dispatchChange();
        return;
    }
    writeForUser(userId, []);
};
